import { get } from 'lodash';
import { ScoreData } from 'modules/analytics/common/types';

export const sumScoreField = (scoreData: ScoreData[], fieldName: string) =>
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  scoreData?.reduce((acc, current: ScoreData) => acc + get(current, fieldName) || 0, 0);

export const sumImproveOpportunitiesAudits = (auditItems: any) => {
  return auditItems?.data?.reduce((acc: number, item: any) => {
    return acc + (item.improveOpportunities.length as number);
  }, 0);
};
